module.exports = __webpack_public_path__ + "static/media/car.0bc01ad0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/sound/car.mp3
// module id = 1447
// module chunks = 0